module.exports = __webpack_public_path__ + "static/img/admissionPg.6f3b7f0f.png";